// eslint-disable-next-line import/no-cycle
export { default as inspectionRoutes } from './routes';
export { default as Inspection } from './InspectionContainer.vue';
